import request from '@/utils/request'
export function login(data) {
  return request({
    url: '/v2/api/ad_user/auth/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/v2/api/ad_user/auth/verify',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/v2/api/ad_user/auth/logout',
    method: 'post'
  })
}

// token续期
export function refreshtoken() {
  return request({
    url: '/v2/api/app/ap_member/auth/refresh_token',
    method: 'get'
  })
}

// 获取用户信息
export function obtainUseInfor(params) {
  return request({
    url: '/v2/api/app/ap_member/member/query_info',
    method: 'get',
    params
  })
}

// 企业注册接口
export function wishmemberAdd(data) {
  return request({
    url: '/v2/api/app/ap_member//wish/member/add',
    method: 'post',
    data
  })
}

// 手机号输入框失焦触发，用于验证申请人的注册情况
export function checkWishMemberIsTrueOther(params) {
  return request({
    url: '/v2/api/app/ap_member//wish/member/checkWishMemberIsTrueOther',
    method: 'get',
    params
  })
}

// 登入接口 爱心企业的登入
export function wishLogin(params) {
  return request({
    url: '/v2/api/app/ap_member//auth/wish/login',
    method: 'post',
    params
  })
}

// 获取验证码接口 爱心企业
export function obtainCode(params) {
  return request({
    url: '/v2/api/app/ap_member//auth/sendVerificationCode',
    method: 'get',
    params
  })
}

// 注册手机号验证
export function checkWishMemberIsTrue(params) {
  return request({
    url: '/v2/api/app/ap_member//wish/member/checkWishMemberIsTrue',
    method: 'get',
    params
  })
}

// 验证码验证
export function verificationCodeIsTrue(params) {
  return request({
    url: '/v2/api/app/ap_member//auth/verificationCodeIsTrue',
    method: 'get',
    params
  })
}

// 更改密码 爱心企业
export function wishMemberForgetPassword(params) {
  return request({
    url: '/v2/api/app/ap_member//wish/member/wishMemberForgetPassword',
    method: 'get',
    params
  })
}

export default { obtainUseInfor,wishmemberAdd,checkWishMemberIsTrueOther,wishLogin,obtainCode,checkWishMemberIsTrue,verificationCodeIsTrue,wishMemberForgetPassword }
